import type { CSSObject } from '@emotion/react'
import { getIrrigationStatusColors } from 'App/Map/_utils/getIrrigationStatusColors'
import type { TIrrigationDeviceStatus } from 'App/Map/types'
import type { TPressureReadingState } from './getPressureReading'

export const NO_DATA_COLORS = getIrrigationStatusColors('unknown')

export const getPressureBadgeColors = ({
  state,
  status,
}: {
  state: TPressureReadingState
  status: TIrrigationDeviceStatus
}) => (state === 'LIVE' ? getIrrigationStatusColors(status) : NO_DATA_COLORS)

export const getPressureBadgeStyle = ({
  state,
  status,
}: {
  state: TPressureReadingState
  status: TIrrigationDeviceStatus
}): CSSObject => {
  const badgeColors = getPressureBadgeColors({ state, status })

  return state === 'STALE' ? { ...badgeColors, borderStyle: 'dashed' } : badgeColors
}
